export default __webpack_public_path__ + "static/media/71t.314f7ede.jpg";